var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsers28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0ZM20.619 23.01c-.804.04-1.277-1.016-.994-1.77.243-.645.375-1.388.375-2.24 0-1.29-.37-2.528-1.038-3.609-.787-1.275-1.181-1.912-1.09-2.312a.976.976 0 0 1 .36-.565c.322-.252.804-.197 1.768-.087a8.746 8.746 0 0 1 3.962 1.485A7.007 7.007 0 0 1 27 19.686v.202c0 1.247-.831 2.354-2.056 2.594a30.654 30.654 0 0 1-4.325.528ZM4.538 13.912A7.008 7.008 0 0 0 1.5 19.686v.202c0 1.247.835 2.337 2.063 2.559 1.473.266 3.6.553 5.937.553 2.336 0 4.464-.287 5.937-.553 1.228-.222 2.063-1.312 2.063-2.56v-.2a7.007 7.007 0 0 0-3.038-5.775 8.76 8.76 0 0 0-9.924 0ZM19 10.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers28);
export default __webpack_public_path__ + "static/media/users_28.fc09c014.svg";
export { ForwardRef as ReactComponent };